<template>
  <v-app>
    <v-container>
      <v-row class="pb-3 mb-3" style="border-bottom: 1px solid #EDEDED">
        <v-col class="col-12">
          <h2 class="mx-2 text-xs-center text-md-left" style="color: var(--v-primary-base)">
            <v-icon size="32" color="primary">date_range</v-icon>Agenda
          </h2>
        </v-col>
      </v-row>
      <v-row class="justify-space-between">
        <v-col class="col-12 col-md-4 col-lg-5">
          <v-date-picker
            v-model="date"
            :events="arrayEvents"
            full-width
            locale="pt-br"
            event-color="secondary"
            color="primary"
          ></v-date-picker>
          <div class="total__schedule px-3 py-2">
            <p>
              Total de atendimentos agendados para o dia {{date | formatDate}} :
              <span>{{total}}</span>
            </p>
          </div>
          <div class="total__time px-3 py-2">
            <p>
              Total de horários disponíveis para o dia {{date | formatDate}} :
              <span>{{total_time_slots}}</span>
            </p>
          </div>
          <div class="py-4 pa-md-3" style="display: flex;justify-content: space-around;">
            <v-btn color="gray" large dark to="edit-schedule">EDITAR AGENDA</v-btn>
            <v-btn color="secondary" large to="create-schedule">CRIAR AGENDA</v-btn>
          </div>
        </v-col>
        <v-col class="col-12 col-md-8 col-lg-7">
          <v-row class="mt-0">
            <v-col class="col-12 pt-0">
              <div class="lightGray px-3 py-2">
                <h3
                  class="font-weight-regular"
                  style="color: var(--v-primary-base)"
                >Consultas do dia:</h3>
              </div>
            </v-col>
            <v-col
              class="col-12 col-md-6 py-0"
              v-for="(item, index) in consultation"
              :key="index"
              :v-if="consultation"
            >
              <v-divider></v-divider>
              <router-link
                tag="div"
                style="cursor: pointer"
                class="my-list"
                :to="{name: 'DetalheConsulta', params: {id: item.id}}"
              >
                <p class="ma-0">{{item.patient.name}}</p>
                <span class="date ma-2 align-end d-flex">
                  <v-icon color="primary">date_range</v-icon>
                  <p class="mb-0 ml-2">{{ date | formatDate }}</p>
                </span>
                <span class="time ma-2 align-end d-flex">
                  <v-icon color="primary">access_time</v-icon>
                  <p class="mb-0 ml-2">{{ item.time | formatDateTZ(item.date) }}</p>
                </span>
              </router-link>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import http from '@/services/httpClient';

export default {
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      arrayEvents: [],
      cod: '',
      consultation: [],
      total: '0',
      total_time_slots: '0',
    };
  },
  async created() {
    await this.getCod();
    await this.allConsultation();
    await this.getConsultation();
    this.totalTimeSlots();
  },
  watch: {
    date(val) {
      this.getConsultation();
      this.totalTimeSlots();
    },
  },
  methods: {
    getCod() {
      this.cod = localStorage.getItem('user-id');
    },
    getConsultation() {
      http
        .get(`/psychologists/${this.cod}/appointments/`, {
          params: {
            date: this.date,
          },
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        })
        .then((response) => {
          this.consultation = response.data;
          // this.consultation.map( (item) => {
          //   this.arrayEvents.push(item.date);
          // })
          this.total = response.data.length;
        });
    },
    totalTimeSlots() {
      http
        .get(`/psychologists/${this.cod}/time_slots/`, {
          params: {
            date: this.date,
          },
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        })
        .then((response) => {
          this.total_time_slots = response.data.length;
        })
        .catch((erro) => {
          console.log(erro);
        });
    },
    allConsultation() {
      http
        .get(`/psychologists/${this.cod}/appointments/`, {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        })
        .then((response) => {
          for (const item of response.data.results) {
            this.arrayEvents.push(item.date);
          }
        });
    },
    // totalConsultations: async function() {
    //   try {
    //     const result =  await http.get(`/psychologists/${this.cod}/appointments/`,
    //     {
    //       headers: {
    //         Authorization: `Token ${localStorage.getItem("user-token")}`
    //       }
    //     });
    //     this.total = result.data.count;
    //     // console.log(result.data.count);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },
};
</script>
<style scoped>
* >>> .dayContainer {
  width: 450px;
  max-width: 450px;
}
.my-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 0;
}
.my-list p {
  flex: 1;
}
.total__schedule {
  background-color: #e3ffe3;
}
.total__time {
  background-color: #fffde3;
}
.total__schedule p,
.total__time p {
  color: #6f6f6f;
  margin: 0;
  position: relative;
}
.total__schedule p span,
.total__time p span {
  color: #02a554;
  font-weight: bold;
  position: absolute;
  right: 5px;
}
</style>
